export default "__VITE_ASSET__CLV7uPqZ__"